import { Flex, useTheme } from '@chakra-ui/react';

import { CollapseSidepanel, Plus, Realign } from 'assets/assetsV1/iconComponents';

import { Button } from 'uiToolkitV1/Button';
import { TextHeader4 } from 'uiToolkitV1/Typography';

const SectionHeader = ({ children, headerText = '', textProps, ...props }) => {
  const theme = useTheme();
  return (
    <Flex h="40px" alignItems="center" justifyContent="space-between" py={1} px={3} {...props}>
      <TextHeader4 bold color={theme.colors.text.g1} {...textProps}>
        {headerText}
      </TextHeader4>
      {children}
    </Flex>
  );
};

const DetailsSectionHeader = () => <SectionHeader headerText="Details" />;
const OverviewSectionHeader = () => <SectionHeader headerText="Overview" />;

const AdditionalInfoHeader = () => <SectionHeader headerText="Additional Info" />;
const InitiativeTaskSectionHeader = ({ headerText, buttonText, onClick = () => {}, isCreationAllowed = false }) => (
  <SectionHeader headerText={headerText}>
    {isCreationAllowed && (
      <Button StartIcon={Plus} variant="outlined" style={{ height: '32px' }} onClick={onClick}>
        {buttonText}
      </Button>
    )}
  </SectionHeader>
);

const ActivitySectionHeader = () => <SectionHeader headerText="Activities" />;
const MeasureSectionHeader = () => <SectionHeader headerText="Measure" />;

const AlignmentSectionHeader = ({ handleRealignClick }) => (
  <SectionHeader headerText="Alignment">
    <Button StartIcon={Realign} variant="outlined" style={{ height: '32px' }} onClick={handleRealignClick}>
      Re-align
    </Button>
  </SectionHeader>
);

const SupportedBySectionHeader = () => <SectionHeader headerText="Supported By" />;

const RealignPanelHeader = ({ headerText = 'Re-align', onCollapse }) => (
  <SectionHeader headerText={headerText}>
    <Button StartIcon={CollapseSidepanel} variant="tertiary" style={{ height: '32px' }} onClick={onCollapse} />
  </SectionHeader>
);
const CreateInitiativePanelHeader = ({ headerText = 'Create Initiative', onCollapse }) => (
  <SectionHeader headerText={headerText}>
    <Button StartIcon={CollapseSidepanel} variant="tertiary" style={{ height: '32px' }} onClick={onCollapse} />
  </SectionHeader>
);

export {
  OverviewSectionHeader,
  DetailsSectionHeader,
  MeasureSectionHeader,
  RealignPanelHeader,
  AlignmentSectionHeader,
  SupportedBySectionHeader,
  InitiativeTaskSectionHeader,
  ActivitySectionHeader,
  CreateInitiativePanelHeader,
  AdditionalInfoHeader,
};
